import { computed } from 'vue'
import { TGridBlockFilter } from '~/types/grid-block-types'
import { pageDefinitions } from '~/constants/pages'
import { usePageStore } from '~/store/page'
import { getSortedPageCards } from '~/services/custom-endpoints'

export const useGetGridData = async (variant: 'custom' | 'new' | 'other' | 'more',
  filters?: TGridBlockFilter[],
  smallCardsPerSlide = 2) => {
  // get self, so we can exclude it
  const currentPage = usePageStore().getCurrentPage
  const numberOfSlides = 12
  const route = useRoute()
  const isHome = route.path === '/'

  const self = {
    id: currentPage.id,
    collection: currentPage.collection,
    domain: (currentPage.domain) ? currentPage.domain.id : undefined
  }

  const { data, error } = await getSortedPageCards(
    variant,
    filters,
    self,
    numberOfSlides * smallCardsPerSlide, // to allow 12 slides of small cards
    isHome // on the homepage
  )

  if (error.value) {
    throw new Error(error.value?.message)
  }

  // check if we need a small or a large card
  const isSmall = (type: string) => {
    return pageDefinitions[type].card?.size === 'small'
  }

  // convert grid data to slides
  const slides = computed(() => {
    const parsedCardData = []
    const slidesData = []

    if (data.value) {
      const smallCardData = data.value.filter((card) => {
        return isSmall(card.collection)
      })

      data.value.forEach((cardData) => {
        if (slidesData.length < numberOfSlides) {
          // due to splicing we need an extra check here
          if (!parsedCardData.includes(cardData)) {
            const small = isSmall(cardData.collection)
            if (!small) {
              // if it's not a small card
              slidesData.push([cardData])
              parsedCardData.push(cardData)
            } else if (smallCardData.includes(cardData)) {
              // only run if the card is still in smallCards
              const slide = []
              for (let i = 0; i < smallCardsPerSlide; i++) {
                if (smallCardData.length > 0) {
                  slide.push(smallCardData.splice(0, 1)[0])
                  parsedCardData.push(cardData)
                }
              }
              slidesData.push(slide)
            }
          }
        }
      })
    }

    return slidesData
  })

  return { slides }
}
